import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareListCustomEmbedRoute: InvariantJiraRoute = {
	name: 'software-list-custom-embed',
	path: '/jira/software/projects/:projectKey/list/:navigationItemId/embed',
};
